import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "name", "label", "isRequired", "validators", "validationHelpText", "testId"],
  _excluded2 = ["fieldId"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import AkTextfield from '@atlaskit/textfield';
import { CreateField } from '../../../controllers/create-field';
export var TEST_ID = 'link-create-text-field';

/**
 * A text field utilising the Atlaskit Textfield and CreateField.
 * Validation is handled by the form as it is on form submission. Any errors returned by
 * the handleSubmit function passed to the form <Form> that have a key matching the `name`
 * of this text field are shown above the field.
 */

export function TextField(_ref) {
  var id = _ref.id,
    name = _ref.name,
    label = _ref.label,
    isRequired = _ref.isRequired,
    validators = _ref.validators,
    validationHelpText = _ref.validationHelpText,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? TEST_ID : _ref$testId,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return jsx(CreateField, {
    id: id,
    name: name,
    label: label,
    isRequired: isRequired,
    validators: validators,
    validationHelpText: validationHelpText,
    testId: testId
  }, function (_ref2) {
    var fieldId = _ref2.fieldId,
      fieldProps = _objectWithoutProperties(_ref2, _excluded2);
    return jsx(AkTextfield, _extends({
      id: fieldId
    }, fieldProps, restProps));
  });
}